import { useLayoutEffect } from 'react'
import { useBoundStore } from '../store'

// Declares that the calling layout permits dark mode while it is mounted.
// This is policy, not lifecycle bookkeeping: a layout that renders themed,
// token-consuming chrome (AppShell today) opts its subtree into the user's
// dark preference; everything outside any scope stays light. useLayoutEffect
// keeps the flip pre-paint, so there's no light flash on first render.
export function useDarkThemeScope(): void {
  const enterDarkScope = useBoundStore((s) => s.enterDarkScope)
  const exitDarkScope = useBoundStore((s) => s.exitDarkScope)

  useLayoutEffect(() => {
    enterDarkScope()
    return exitDarkScope
  }, [enterDarkScope, exitDarkScope])
}
